import { render, staticRenderFns } from "./studentIntelligentBodyDialogue.vue?vue&type=template&id=43cf3cad&scoped=true"
import script from "./studentIntelligentBodyDialogue.vue?vue&type=script&lang=js"
export * from "./studentIntelligentBodyDialogue.vue?vue&type=script&lang=js"
import style0 from "./studentIntelligentBodyDialogue.vue?vue&type=style&index=0&id=43cf3cad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cf3cad",
  null
  
)

export default component.exports